<template>
  <span
    v-if="source"
    class="inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded"
    :class="badgeClass"
  >
    <FontAwesomeIcon :icon="icon" class="text-[9px]" />
    {{ label }}
  </span>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const SOURCE_CONFIG = {
  email: {
    label: 'Email',
    icon: ['fas', 'envelope'],
    class: 'bg-blue-50 text-blue-700',
  },
  web: {
    label: 'Web',
    icon: ['fas', 'globe'],
    class: 'bg-gray-100 text-gray-600',
  },
  internal_note: {
    label: 'Internal Note',
    icon: ['fas', 'lock'],
    class: 'bg-amber-50 text-amber-700',
  },
};

export default {
  name: 'SourceBadge',
  components: { FontAwesomeIcon },
  props: {
    source: { type: String, default: null },
  },
  computed: {
    config() {
      return SOURCE_CONFIG[this.source] || SOURCE_CONFIG.web;
    },
    label() {
      return this.config.label;
    },
    icon() {
      return this.config.icon;
    },
    badgeClass() {
      return this.config.class;
    },
  },
};
</script>
